module.exports = __webpack_public_path__ + "static/media/Logo_TELUS_fr.1267589e.png";